var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "report-tab-layout",
    {
      scopedSlots: _vm._u([
        {
          key: "card-footer",
          fn: function () {
            return [
              _c("mortgage-calculators-toolbar", {
                attrs: {
                  "is-loading": _vm.isLoading,
                  "loading-succeeded": _vm.loadingSucceeded,
                  "show-calculate": false,
                },
                on: {
                  "clear-selection": _vm.handleClearSelection,
                  "set-default": function ($event) {
                    return _vm.amortLink(-1)
                  },
                  "run-report": _vm.runReport,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "span",
        [
          _c("b-row", { staticClass: "ml-1" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("financial-tools.prepayment_analyzer_description")
                ) +
                "\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        1. " +
                      _vm._s(_vm.$t("financial-tools.mortgage_amount")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.mortgage_amount_descriptionpre"
                        ),
                        expression:
                          "\n            $t('financial-tools.mortgage_amount_descriptionpre')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "mortgageAmount",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm
                        .$t("financial-tools.mortgage_amount")
                        .toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.mortgageAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "mortgageAmount", $$v)
                      },
                      expression: "inoudata.mortgageAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.calcMortgage(0)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.calculate")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        2. " +
                      _vm._s(_vm.$t("financial-tools.interest_rate")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.interest_rate_description"
                        ),
                        expression:
                          "\n            $t('financial-tools.interest_rate_description')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      placeholder: "0",
                      "class-name": "fe-num-field decimal-input",
                      decimals: 3,
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.interest_rate").toString(),
                      max: "100",
                      "max-length": 6,
                      "show-tooltip-message": true,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.interestRate,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "interestRate", $$v)
                      },
                      expression: "inoudata.interestRate",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.calcMortgage(1)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.calculate")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        3. " +
                      _vm._s(
                        _vm.$t("financial-tools.initialAmortizationPeriod")
                      ) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.amortization_period_description"
                        ),
                        expression:
                          "\n            $t('financial-tools.amortization_period_description')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("years-months-section", {
                    attrs: {
                      name: "amortizPeriodMths",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      label: _vm.$t("application-form.amortization").toString(),
                      "show-tooltip-message": true,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.amortizPeriodMths,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "amortizPeriodMths", $$v)
                      },
                      expression: "inoudata.amortizPeriodMths",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.calcMortgage(2)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.calculate")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        4. " +
                      _vm._s(_vm.$t("financial-tools.initialPandI")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.initialPandIDescription"
                        ),
                        expression:
                          "\n            $t('financial-tools.initialPandIDescription')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "PandI",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm.$t("financial-tools.initialPandI").toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.PandI,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "PandI", $$v)
                      },
                      expression: "inoudata.PandI",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "12", sm: "2" } },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-md-2 ml-0 btn-sm",
                      attrs: { variant: "white" },
                      on: {
                        click: function ($event) {
                          return _vm.calcMortgage(3)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("financial-tools.calculate")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-2" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        5. " +
                      _vm._s(_vm.$t("application-form.payment-frequency")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.paymentFrequencyTermDescription"
                        ),
                        expression:
                          "\n            $t('financial-tools.paymentFrequencyTermDescription')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pl-0", attrs: { cols: "12", sm: "3" } },
                [
                  _c("select-section", {
                    attrs: {
                      name: "frequency",
                      options: _vm.mortgageFrequencyOptions,
                      required: true,
                      "placeholder-option": false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.frequency,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "frequency", $$v)
                      },
                      expression: "inoudata.frequency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        6. " +
                      _vm._s(_vm.$t("financial-tools.lumpSumPayment")) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.annualPrepaymentDescriptionForLump"
                        ),
                        expression:
                          "\n            $t('financial-tools.annualPrepaymentDescriptionForLump')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "lumpAmt",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm
                        .$t("financial-tools.lumpSumPayment")
                        .toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.lumpAmt,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "lumpAmt", $$v)
                      },
                      expression: "inoudata.lumpAmt",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", {
                staticClass: "align-items-center pt-2",
                attrs: { cols: "12", sm: "1" },
              }),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.periodYears")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "lumpYears",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      "show-tooltip-message": true,
                      max: "40",
                      "max-length": 2,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.lumpYears,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "lumpYears", $$v)
                      },
                      expression: "inoudata.lumpYears",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "3" },
                },
                [
                  _vm._v(
                    "\n        7. " +
                      _vm._s(
                        _vm.$t("financial-tools.mortgagePaymentIncrease")
                      ) +
                      "\n        "
                  ),
                  _c("icon", {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip.bottom.html",
                        value: _vm.$t(
                          "financial-tools.mortgagePaymentIncreaseDescription"
                        ),
                        expression:
                          "\n            $t('financial-tools.mortgagePaymentIncreaseDescription')\n          ",
                        modifiers: { bottom: true, html: true },
                      },
                    ],
                    staticClass: "ml-2 registered-tooltip",
                    attrs: { name: "info-circle" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "2" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "incpayValue",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar",
                      "allow-minus": false,
                      label: _vm
                        .$t("financial-tools.mortgagePaymentIncrease")
                        .toString(),
                      "show-tooltip-message": true,
                      max: "100000000",
                      "max-length": 14,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.incpayValue,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "incpayValue", $$v)
                      },
                      expression: "inoudata.incpayValue",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-0",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _c("select-section", {
                    attrs: {
                      name: "incpayType",
                      options: [
                        { label: "$", value: "$" },
                        { label: "%", value: "%" },
                      ],
                      required: true,
                      "placeholder-option": false,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.incpayType,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "incpayType", $$v)
                      },
                      expression: "inoudata.incpayType",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "align-items-center pt-2",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.periodYears")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "m-0 p-0 mr-0 pb-1",
                  attrs: { cols: "12", sm: "1" },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "incYears",
                      placeholder: "0",
                      "class-name": "fe-num-field",
                      "allow-minus": false,
                      "show-tooltip-message": true,
                      max: "40",
                      "max-length": 2,
                    },
                    on: {
                      change: function ($event) {
                        return _vm.inoudata.doHideAMsched()
                      },
                    },
                    model: {
                      value: _vm.inoudata.incYears,
                      callback: function ($$v) {
                        _vm.$set(_vm.inoudata, "incYears", $$v)
                      },
                      expression: "inoudata.incYears",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt-4 text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.controlMortgage(1)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("financial-tools.calculate")) +
                      "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "mt-4 text-left" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm
                    .$t("financial-tools.revisedAmortizationPeriodPrefix")
                    .toString() +
                    Math.trunc(_vm.inoudata.revamortizPeriodMths / 12) +
                    _vm.$t("financial-tools.revisedAmortizationPeriodInfix1") +
                    Math.round(_vm.inoudata.revamortizPeriodMths % 12) +
                    _vm.$t("financial-tools.revisedAmortizationPeriodInfix2") +
                    _vm.formatMoneyValueLong(_vm.inoudata.interestSavings) +
                    _vm.$t("financial-tools.revisedAmortizationPeriodSuffix")
                ) +
                "\n    "
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("mortgage-amschedule", {
        attrs: { inoudata: _vm.inoudata },
        on: { generated: _vm.generatedAmSchedule },
      }),
      _vm._v(" "),
      !_vm.inoudata.showAMsched
        ? _c(
            "div",
            { staticClass: "mt-4 text-center" },
            [
              _c(
                "b-button",
                {
                  staticClass: "ml-md-2 ml-0 btn-sm",
                  attrs: { variant: "white" },
                  on: {
                    click: function ($event) {
                      return _vm.amortLink(-1)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "financial-tools.calculate_amortization_schedule"
                        )
                      ) +
                      "\n    "
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("b-row", { staticClass: "mt-4 ml-1" }, [
        _vm._v(
          "\n    " + _vm._s(_vm.$t("financial-tools.DHdisclaimer")) + "\n  "
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }